import Default from '../default/';
import {setMethodsFromAttrs} from '../../modules/util';
import _munge from './_munge';
import _scale from './_scale';
import _mark from './_mark';
import _legend from './_legend';
import _tooltip from './_tooltip';

const size = {range: [0, 150], scale: 'linear', reverse: false}; 
const conditions = ['normal', 'count'];
const _attrs = {
  limitKeys: 20,
  padding: 0,
  size: size
};

class Pie extends Default {
  constructor() {
    super(_attrs);
  }
}

function _pie() {
  let pie =  new Pie();
  return pie;
}

function axis() {
  if(!arguments.length) return [];
  return this;
}

function dehighlight(selection) {
  selection.select('path').style('fill', d => d.color);
}

function highlight(selection, highlightColor) {
  selection.select('path').style('fill', highlightColor); //TODO: highlight 이외에 
}

function muteFromLegend(legend) {
  this.muteNodes(d => d.data.key !== legend.key);
}

function highlightToLegend(d) {
  this.__execs__.legend.highlight(d.data.key);
}

function dehighlightToLegend(d) {
  this.__execs__.legend.dehighlight(d.data.key);
}

function demuteFromLegend(legend) {
  this.demuteNodes(d => d.data.key !== legend.key);
}

function muteToLegend(d) {
  this.muteLegend(d.data.key);
}

function demuteToLegend(d) {
  this.demuteLegend(d.data.key);
}

function update() {
 // 데이터가 바뀐 경우

 // 데이터의 계산에 영향 주는 요소가 바뀐 경우

 // 다른 화면 요소가 바뀐 경우 
}

function isCount() {
  return this.condition() === conditions[1];
}

function renderLayout(keep) { //완벽히 처음부터 업데이트 
  this.reset(keep);
  this.renderFrame();
  _munge.call(this);
  _scale.call(this, keep);
  this.renderCanvas();
  _mark.call(this); 
  _legend.call(this);
  _tooltip.call(this);
}
Pie.prototype.axis = axis;
Pie.prototype.renderLayout = renderLayout;
Pie.prototype.update = update;
Pie.prototype.isCount = isCount;
Pie.prototype.highlight = highlight;
Pie.prototype.muteFromLegend = muteFromLegend;
Pie.prototype.highlightToLegend = highlightToLegend;
Pie.prototype.dehighlight = dehighlight;
Pie.prototype.demuteFromLegend = demuteFromLegend;
Pie.prototype.dehighlightToLegend = dehighlightToLegend;
Pie.prototype.muteToLegend = muteToLegend;
Pie.prototype.demuteToLegend = demuteToLegend;

setMethodsFromAttrs(Pie, _attrs);

export default _pie;
export {conditions};



// WEBPACK FOOTER //
// ./layouts/pie/index.js